enum ImportActualsStatusEnum {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  NOT_IMPORTED_YET = 'NOT_IMPORTED_YET'
}

export default ImportActualsStatusEnum;
